<div class="user-access px-4 py-4">
  <div class="header mt-1 mb-4 w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 mb-4 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          *ngIf="stepper > 1"
          (click)="
            !toggleDateForm && !toggletimeForm
              ? navigateToAddGroup()
              : resetToggleFormState()
          "
        />
      </span>

      <div class="d-flex flex-column justify-content-center col-8 mr-4">
        <span class="user-title ">
          <app-with-tooltip [showHelpCursor]="true">{{
            formInstanceUserDetail?.name?.value
          }}</app-with-tooltip></span
        >
        <span class="modal-title m-auto">{{ 'UPDATE_ACCESS' | translate }}</span>
      </div>
      <!-- dynamic back button render -->
      <ng-content select="[closeButton]"></ng-content>
    </div>
  </div>
  <div class="d-flex pt-2">
    <h2 class="heading1 bold-font m-auto">
      {{ 'ACCESS_TIME' | translate }}
    </h2>
  </div>
  <div class="text-center px-4 mt-3">
    {{
      commonService.stringInterPolation(
        ("DEFINE_ACCESS_TIME_FOR_YOUR" | translate),
        [this.formInstanceUserDetail?.name?.value, siteTimeZone]
      )
    }}
  </div>

  <!-- step form start -->
  <form
    [formGroup]="formGroup"
    class="mt-4 pt-3"
    (ngSubmit)="submit()"
    novalidate
    *ngIf="!toggleDateForm && !toggletimeForm"
  >
    <div class="group-container scroll-container p-2" #weekListScrollTarget>
      <div class="form-group rounded-top form-container">
        <mat-form-field
          appearance="fill"
          class="w-100 list-container primary-input bottom-zero padding-top-balance first"
          [class.container-invalid]="f?.startTime?.errors?.required && submited"
        >
          <div class="d-flex justify-content-between list-box">
            <div class="title">{{ 'STARTS' | translate }}</div>
            <div class="selected-value width-225">
              <app-with-tooltip [showHelpCursor]="true">{{
                formInstance.startTime?.value
                  | parsedDateTime : "EEE, MMM do, yyyy 'at' h:mm a"  : "EEE, MMM do, yyyy 'at' h:mm a"
              }}</app-with-tooltip>
            </div>
            <div
              [ngClass]="{ 'btn-list': !formInstance?.repeat?.value }"
              *ngIf="!formInstance.startTime?.value"
            >
              <button
                [ngClass]="{
                  'w-100':
                    formInstance?.repeat?.value === false ||
                    formInstance?.repeat?.value === null
                }"
                class="pointer-cursor"
                mat-icon-button
                aria-label="startTime"
                (click)="
                  formInstance?.repeat?.value === false ||
                  formInstance?.repeat?.value === null
                    ? selectDate(
                        {
                          name: 'startTime',
                          value: formInstance.startTime?.value
                        },
                        'startTime'
                      )
                    : false
                "
              >
                <span
                  [ngClass]="{
                    'disabled-label label-left':
                      formInstance?.repeat?.value === true &&
                      formInstance?.repeat?.value !== null
                  }"
                >
                  {{ 'ACCESS_TIME_NOW' | translate }}
                </span>
                <ng-container
                  *ngIf="
                    formInstance?.repeat?.value === false ||
                    formInstance?.repeat?.value === null
                  "
                >
                  <mat-icon>arrow_forward_ios</mat-icon>
                </ng-container>
              </button>
            </div>

            <div class="btn-cross" *ngIf="formInstance.startTime?.value">
              <span
                class="pointer-cursor"
                (click)="removeValue(formInstance.startTime, 'startTime')"
              >
                <img
                  src="/assets/svg/ico-circle-cross-red.svg"
                  alt="Cross Button"
                />
              </span>
            </div>
          </div>
          <input
            matInput
            [placeholder]="'START_DATE' | translate"
            formControlName="startTime"
            class="d-none"
          />
          <mat-error
            *ngIf="formInstance?.startTime?.errors?.zoneStartTimeValidator"
            class="pb-3"
          >
            {{ 'FAILED_START_TIME_IS_EARLIER_THAN_CURRENT_TIME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        class="form-group rounded-top form-container"
        [ngClass]="{
          'mt-40': formInstance?.startTime?.errors?.zoneStartTimeValidator
        }"
      >
        <mat-form-field
          appearance="fill"
          class="w-100 list-container primary-input bottom-zero padding-top-balance last"
        >
          <div class="d-flex justify-content-between list-box">
            <div class="title">{{ 'EXPIRES' | translate }}</div>
            <div class="selected-value width-225">
              <app-with-tooltip [showHelpCursor]="true">{{
                formInstance.expireTime?.value
                  | parsedDateTime : "EEE, MMM do, yyyy 'at' h:mm a"  : "EEE, MMM do, yyyy 'at' h:mm a"
              }}</app-with-tooltip>
            </div>
            <div
              *ngIf="!formInstance.expireTime?.value"
              [ngClass]="{
                'btn-optional':
                  formInstance?.repeat?.value === false ||
                  formInstance?.repeat?.value === null
              }"
            >
              <button
                mat-icon-button
                class="pointer-cursor w-100"
                aria-label="expireTime"
                (click)="
                  formInstance?.repeat?.value === false ||
                  formInstance?.repeat?.value === null
                    ? selectDate(
                        {
                          name: 'expireTime',
                          value: formInstance.expireTime?.value
                        },
                        'expireTime'
                      )
                    : false
                "
              >
                <ng-container
                  *ngIf="
                    formInstance?.repeat?.value === true &&
                      formInstance?.repeat?.value !== null;
                    else optional
                  "
                >
                  <span
                    class="btn-optional-not-arrow"
                    [ngClass]="{
                      'disabled-label': formInstance?.repeat?.value
                    }"
                  >
                    {{ 'NEVER' | translate }}
                  </span>
                </ng-container>

                <ng-template #optional>
                  <span>
                    {{ 'ACCESS_TIME_OPTIONAL' | translate }}
                  </span>
                  <mat-icon>arrow_forward_ios</mat-icon>
                </ng-template>
              </button>
            </div>

            <div class="btn-cross" *ngIf="formInstance.expireTime?.value">
              <span
                class="pointer-cursor"
                (click)="removeValue(formInstance.expireTime, 'expireTime')"
              >
                <img
                  src="/assets/svg/ico-circle-cross-red.svg"
                  alt="Cross Button"
                />
              </span>
            </div>
          </div>

          <input
            matInput
            [placeholder]="'EXPIRE_TIME' | translate"
            formControlName="expireTime"
            class="d-none"
          />

          <mat-error
            *ngIf="
              formInstance?.expireTime?.errors?.dateValidator &&
              formInstance?.expireTime?.errors?.zoneTimeValidator
            "
            class="pb-3"
          >
            {{ 'FAILED_END_TIME_IS_EARLIER_THAN_CURRENT_TIME' | translate }}
          </mat-error>

          <mat-error
            *ngIf="
              formInstance?.expireTime?.errors?.dateValidator &&
              !formInstance?.expireTime?.errors?.zoneTimeValidator
            "
            class="pb-3"
            >{{
              'FAILED_END_TIME_IS_EARLIER_THAN_START_TIME' | translate
            }}</mat-error
          >
          <mat-error
            *ngIf="
              !formInstance?.expireTime?.errors?.dateValidator &&
              formInstance?.expireTime?.errors?.zoneTimeValidator
            "
            class="pb-3"
          >
            {{ 'FAILED_END_TIME_IS_EARLIER_THAN_CURRENT_TIME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        [ngClass]="{
          'mt-35':
            formInstance?.expireTime?.errors?.dateValidator ||
            formInstance?.expireTime?.errors?.zoneTimeValidator
        }"
        class="form-group row form-container slide-toggle-primary first mb-7"
        [class.first]="formInstance.repeat.value"
      >
        <div class="col-2 pt-1">
          <mat-label class="title">{{
            'ACCESS_TIME_REPEAT' | translate
          }}</mat-label>
        </div>
        <div class="col-10 text-right">
          <mat-slide-toggle
            class="mat-toggle"
            color="primary"
            formControlName="repeat"
            (change)="changeRepeat(weekListScrollTarget)"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div>
        <ng-container *ngIf="formInstance.repeat.value">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input padding-top-balance middle bottom-zero"
            >
              <div class="d-flex listing-box">
                <span class="title">{{
                  'ACCESS_TIME_START_TIME' | translate
                }}</span>
                <span class="selected-value-container">
                  <span class="selected-value time-right">
                    {{ formInstance.repeatStartTime?.value }}
                  </span>
                  <span class="btn-not-text">
                    <button
                      mat-icon-button
                      aria-label="Repeat StartTime"
                      class="pointer-cursor"
                      (click)="
                        selectTime([
                          {
                            name: 'repeatStartTime',
                            value: formInstance.repeatStartTime?.value
                          },
                          {
                            name: 'repeatEndTime',
                            value: formInstance.repeatEndTime?.value
                          }
                        ])
                      "
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </span>
                </span>
              </div>

              <input
                matInput
                [placeholder]="'ACCESS_TIME_START_TIME' | translate"
                formControlName="repeatStartTime"
                class="d-none"
              />
            </mat-form-field>
          </div>

          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input padding-top-balance middle bottom-zero"
            >
              <div class="d-flex justify-content-between listing-box">
                <span class="title">{{ 'ACCESS_TIME_END_TIME' | translate }}</span>

                <span class="selected-value-container">
                  <span class="selected-value w-75 time-right">
                    {{ formInstance.repeatEndTime?.value }}
                  </span>

                  <span class="btn-not-text">
                    <button
                      mat-icon-button
                      aria-label="Repeat End Time"
                      class="pointer-cursor"
                      (click)="
                        selectTime([
                          {
                            name: 'repeatStartTime',
                            value: formInstance.repeatStartTime?.value
                          },
                          {
                            name: 'repeatEndTime',
                            value: formInstance.repeatEndTime?.value
                          }
                        ])
                      "
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </span>
                </span>
              </div>

              <input
                matInput
                [placeholder]="'ACCESS_TIME_END_TIME' | translate"
                formControlName="repeatEndTime"
                class="d-none"
              />
            </mat-form-field>
          </div>

          <div class="weeksList round-bottom">
            <p class="title">{{ 'ACCESS_TIME_DAYS_OF_THE_WEEK' | translate }}</p>
            <input type="input" class="d-none" formControlName="repeatDays" />
            <div class="d-flex justify-content-between">
              <ng-container *ngFor="let week of weekArray; let i = index">
                <div
                  class="day pointer-cursor"
                  [class.error]="formInstance?.repeatDays?.errors"
                  (click)="AddRemoveDays(week)"
                  [class.active]="week.active"
                >
                  <span>
                    {{ week.label }}
                  </span>
                </div>
              </ng-container>
            </div>
          </div>
          <mat-error>
            <span
              class="mat-error weekly-error"
              *ngIf="formInstance?.repeatDays?.errors?.required"
              >{{ 'ACCESS_TIME_WEEK_REQURED' | translate }}</span
            >
          </mat-error>
        </ng-container>
      </div>
    </div>

    <div class="row mt-28">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          [disabled]="formGroup?.invalid"
          type="submit"
        >
          {{ 'UPDATE' | translate }}
        </button>
      </div>
    </div>
  </form>
  <!-- step form end -->

  <!-- calendar form start -->
  <div *ngIf="toggleDateForm" (keyup.enter)="submitDateTime()">
    <div class="overflow-y-date">
      <div class="group-container">
        <div class="form-group form-container">
          <ng-container *ngIf="calendarValidateMinMax === 'startTime'">
            <mat-calendar
              [(selected)]="calendarDate.value"
              [maxDate]="calendarMaxValue"
              [minDate]="calendarConvertedStartDate"
              (selectedChange)="updateFormDate($event)"
            >
            </mat-calendar>
          </ng-container>

          <ng-container *ngIf="calendarValidateMinMax === 'expireTime'">
            <mat-calendar
              [(selected)]="calendarDate.value"
              [minDate]="calendarConvertedStartDate"
              [maxDate]="calendarMaxValue"
              (selectedChange)="updateFormDate($event)"
            >
            </mat-calendar>
          </ng-container>
        </div>
      </div>

      <div class="time-select pt-2">
        <p>
          {{
            (calendarValidateMinMax === "startTime"
              ? "ACCESS_TIME_START_TIME"
              : "ACCESS_TIME_END_TIME") | translate
          }}
        </p>

        <div class="group-container">
          <div class="form-group form-container d-flex justify-content-between">
            <input
              matInput
              [placeholder]="'HOUR' | translate"
              class="time"
              type="number"
              min="0"
              max="12"
              [(ngModel)]="hour"
              (keyup)="checkHour($event)"
              autocomplete="off"
            />
            <span class="colon">:</span>
            <input
              matInput
              [placeholder]="'MINUTE' | translate"
              type="number"
              class="time"
              [(ngModel)]="minute"
              (keyup)="checkMinutes($event)"
              min="0"
              max="59"
              autocomplete="off"
            />

            <div>
              <button
                class="meridiem"
                (click)="meridiem = 'AM'"
                [class.active-left]="meridiem === 'AM'"
                [disabled]="
                  hour === '' ||
                  hour === null ||
                  minute === '' ||
                  minute === null
                "
                [class.not-active-left]="meridiem !== 'AM'"
              >
                {{ 'ACCESS_TIME_AM' | translate }}
              </button>
              <button
                class="meridiem"
                (click)="meridiem = 'PM'"
                [class.active-right]="meridiem === 'PM'"
                [disabled]="
                  hour === '' ||
                  hour === null ||
                  minute === '' ||
                  minute === null
                "
                [class.not-active-right]="meridiem !== 'PM'"
              >
                {{ 'ACCESS_TIME_PM' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          [disabled]="
            !calendarDate.value ||
            hour === '' ||
            hour === null ||
            minute === '' ||
            minute === null ||
            !meridiem
          "
          type="button"
          (click)="submitDateTime()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- calendar form end -->

  <!-- start time and time form start -->
  <div *ngIf="toggletimeForm">
    <!-- Error messages -->
    <div
      class="mb-2 mt-4 mx-2 alert alert-danger alert-dismissible fade show notification-alert"
      role="alert"
      *ngIf="errorMessage"
    >
      {{ errorMessage }}
      <button type="button" class="close" (click)="closeError()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div
      [ngClass]="{
        'pb-120': !errorMessage,
        'pb-102': errorMessage
      }"
    >
      <div class="time-select mb-4 mt-4">
        <p>
          {{ 'ACCESS_TIME_START_TIME' | translate }}
        </p>

        <div class="group-container">
          <div class="form-group form-container d-flex justify-content-between">
            <input
              matInput
              [placeholder]="'HOUR' | translate"
              class="time"
              type="number"
              min="0"
              max="12"
              [(ngModel)]="hourStartRepeatTime"
              (keyup)="checkHour($event)"
              autocomplete="off"
            />
            <span class="colon">:</span>
            <input
              matInput
              [placeholder]="'MINUTE' | translate"
              type="number"
              class="time"
              [(ngModel)]="minuteStartReapeatTime"
              (keyup)="checkMinutes($event)"
              min="0"
              max="59"
              autocomplete="off"
            />

            <div>
              <button
                class="meridiem"
                (click)="meridiemStartRepeatTime = 'AM'"
                [class.active-left]="meridiemStartRepeatTime === 'AM'"
                [disabled]="
                  !hourStartRepeatTime ||
                  !utility.stringContainsNumber(minuteStartReapeatTime)
                "
                [class.not-active-left]="meridiemStartRepeatTime !== 'AM'"
              >
                {{ 'ACCESS_TIME_AM' | translate }}
              </button>
              <button
                class="meridiem"
                (click)="meridiemStartRepeatTime = 'PM'"
                [class.active-right]="meridiemStartRepeatTime === 'PM'"
                [disabled]="
                  !hourStartRepeatTime ||
                  !utility.stringContainsNumber(minuteStartReapeatTime)
                "
                [class.not-active-right]="meridiemStartRepeatTime !== 'PM'"
              >
                {{ 'ACCESS_TIME_PM' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="time-select mb-4">
        <p>{{ 'ACCESS_TIME_END_TIME' | translate }}</p>

        <div class="group-container">
          <div class="form-group form-container d-flex justify-content-between">
            <input
              matInput
              [placeholder]="'HOUR' | translate"
              class="time"
              type="number"
              min="0"
              max="12"
              [(ngModel)]="hourEndRepeatTime"
              (keyup)="checkHour($event)"
              autocomplete="off"
            />
            <span class="colon">:</span>
            <input
              matInput
              [placeholder]="'MINUTE' | translate"
              type="number"
              class="time"
              [(ngModel)]="minuteEndReapeatTime"
              (keyup)="checkMinutes($event)"
              min="0"
              max="59"
              autocomplete="off"
            />

            <div>
              <button
                class="meridiem"
                (click)="meridiemEndRepeatTime = 'AM'"
                [class.active-left]="meridiemEndRepeatTime === 'AM'"
                [disabled]="
                  !hourEndRepeatTime ||
                  !utility.stringContainsNumber(minuteEndReapeatTime)
                "
                [class.not-active-left]="meridiemEndRepeatTime !== 'AM'"
              >
                {{ 'ACCESS_TIME_AM' | translate }}
              </button>
              <button
                class="meridiem"
                (click)="meridiemEndRepeatTime = 'PM'"
                [class.active-right]="meridiemEndRepeatTime === 'PM'"
                [disabled]="
                  !hourEndRepeatTime ||
                  !utility.stringContainsNumber(minuteEndReapeatTime)
                "
                [class.not-active-right]="meridiemEndRepeatTime !== 'PM'"
              >
                {{ 'ACCESS_TIME_PM' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-28">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          [disabled]="
            !hourStartRepeatTime ||
            !utility.stringContainsNumber(minuteStartReapeatTime) ||
            !meridiemStartRepeatTime ||
            !hourEndRepeatTime ||
            !utility.stringContainsNumber(minuteEndReapeatTime) ||
            !meridiemEndRepeatTime
          "
          (click)="submitStartTime()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- start time and time form start -->
</div>
